import AppConfig from '@/AppConfig';

/**
 * API UPDATE MARCH 5th
 * - since we couldn't get MSAL.js to work with Vue
 * we are now going with .NET returning the Vue app
 * the API still has references to $auth - most of this should
 * be cleaned up when more time is allowed.
 */

declare let window: any;

export default class API {
  async getToken(requestObject: any): Promise<string> {
    /**
     * We're now using .net to pass window._bearer token for our auth
     * no more msal.js - which doesn't work.
     */
    let bearerToken: string = window._bearer;
    // If no Bearer Token is Provided. Get it
    if (!bearerToken) {
      console.log('🔴🔴🔴 MISSING BEARER TOKEN');
    }
    return bearerToken;
  }

  // Moving query to here so we can play with a local bearer token
  public async query(
    endpoint: string,
    requestObject: any,
    method = 'GET',
    body?: any
  ): Promise<Response> {
    let bearerToken: string = await this.getToken(requestObject);
    const headers = new Headers();
    const bearer = 'Bearer ' + bearerToken;

    headers.append('Authorization', bearer);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');

    const options = {
      method,
      headers,
      body: JSON.stringify(body)
    };
    return fetch(endpoint, options);
  }
  /**
   * Generic Get
   * @param path
   */
  async get(path: string): Promise<any> {
    try {
      let response: Response = await this.query(
        // let response: Response = await this.query(
        `${AppConfig.api.root}/${path}`,
        {
          scopes: ['https://indycar.onmicrosoft.com/api/FantasyRacingApp.Read']
        }
      );
      let res = await response.json();
      if (response.status == 200) {
        return res;
      } else {
        throw new Error(`Unexpected response code: ${response.status}`);
      }
    } catch (e) {
      throw new Error(`Error from Service: ${e.message}`);
    }
  }
  /**
   * Generic Post
   * @param url
   * @param payload
   * @param headers
   */
  async post(path: string, payload: any, headers?: any) {
    try {
      let response = await this.query(
        `${AppConfig.api.root}/${path}`,
        {
          scopes: ['https://indycar.onmicrosoft.com/api/FantasyRacingApp.Read']
        },
        'POST',
        payload
      );
      let res = await response.json();
      if (response.status == 200) {
        return res;
      } else {
        throw new Error(`Unexpected response code: ${response.status}`);
      }
    } catch (e) {
      throw new Error(`Error from Service: ${e.message}`);
    }
  }
  /**
   * Generic Put
   * @param url
   * @param payload
   * @param headers
   */
  async put(path: string, payload: any, headers?: any) {
    try {
      let response = await this.query(
        `${AppConfig.api.root}/${path}`,
        {
          scopes: ['https://indycar.onmicrosoft.com/api/FantasyRacingApp.Read']
        },
        'PUT',
        payload
      );
      let res = await response.json();
      if (response.status == 200) {
        return res;
      } else {
        throw new Error(`Unexpected response code: ${response.status}`);
      }
    } catch (e) {
      throw new Error(`Error from Service: ${e.message}`);
    }
  }

  /**
   * Generic Delete
   * @param url
   * @param payload
   * @param headers
   */
  async delete(path: string, payload: any, headers?: any) {
    try {
      let response = await this.query(
        `${AppConfig.api.root}/${path}`,
        {
          scopes: ['https://indycar.onmicrosoft.com/api/FantasyRacingApp.Read']
        },
        'DELETE',
        payload
      );
      if (response.status == 200) {
        return true;
      } else {
        throw new Error(`Unexpected response code: ${response.status}`);
      }
    } catch (e) {
      throw new Error(`Error from Service: ${e.message}`);
    }
  }
}
